import { render, staticRenderFns } from "./AddRedemptionModal.vue?vue&type=template&id=0a76a878&scoped=true&"
import script from "./AddRedemptionModal.vue?vue&type=script&lang=ts&"
export * from "./AddRedemptionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a76a878",
  null
  
)

export default component.exports